module.exports = __webpack_public_path__ + "static/logo-2a23f21b0d3facae9130b5718ae8842f.png";